<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
             <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-5.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z9-ytj.png) center center no-repeat;background-size:400%,100%,cover;">
                </div>
            </div> -->
            <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">

            <!--解决方案-->
            <div class="w100 lh40 tc"> <span class="db f38 fb lp2 mt40">公共安全行业解决方案</span> <span
                    class="db f20  lp2 mt10 ph-col-gr">Security Industry Solutions</span> </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">行业痛点</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">追踪能力有限</span></strong><br>
                    传统视频及追踪系统功能单一，仅能针对录入系统的固定人员，凭借人脸识别技术实现定位与追踪。一旦面对嫌疑人具备多种特征素材，如不同伪装下的外貌特征、特殊肢体动作习惯，或是多种特征组合情况，系统便难以精准定位，无法有效锁定目标。
                </p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">无法实时预警</span></strong><br>
                    当前视频系统难以从海量视频数据中提前识别潜在风险，无法依据视频分析对可能发生的危险行为、可疑人员聚集等情况发出预警，错过防控风险的最佳时机。</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">人工筛查低效</span></strong><br>
                    面对突发安全事件，需快速从大量视频监控中获取关键信息。目前主要依靠大量警力进行人工监控筛查，人工筛查易因疲劳、注意力分散等因素产生错漏，导致重要线索被忽视。</p>
            </div>
            <!--解决方案end-->

            <!--产品-->
            <div class="ph-sthz clearfloat ov mt20 ">
                <div class="w100 tc mt20 white"> <span class="db f40 fb lp2 mt40">方案架构</span> <span
                        class="db f20  lp2 mt10 ">Solution Architecture</span> </div>
                <div class="ph-jcrj jz mt30 p10">
                    <div class="ph-jcrj-a jz mt26"><img src="../../assets/mobile/images/za6-ytj.png" width="95%"
                            alt="" /></div>
                </div>
            </div>

            <!--产品end-->
        </div>
        <!--内容大框end-->
        <div class="w100 lh40 tc mt20"> <span class="db f40 fb lp2 mt40">应用场景</span> <span
                class="db f20  lp2 mt10 ph-col-gr">Application Scenario</span> </div>
        <div class="ph-yycjdi jz mt20 ov">
            <ul class="w100">
                <li class="ov"> <img src="../../assets/mobile/images/gan-1.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">01</div>
                        <div class="ph-col-gr5 f16 tc fb">暴力攻击行为识别</div>
                        <div class="white f16 tc pt40">打架 互殴 等行为</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">02</div>
                        <div class="ph-col-gr5 f16 tc fb">警务人员力量识别</div>
                        <div class="white f16 tc pt40">警员、各类警务车辆识别</div>
                    </div>
                    <img src="../../assets/mobile/images/gan-2.jpg" width="100%" height="100%" alt="" />
                </li>
                <li class="ov"><img src="../../assets/mobile/images/gan-3.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">03</div>
                        <div class="ph-col-gr5 f16 tc fb">拉条幅行为识别</div>
                        <div class="white f16 tc pt40">拉条幅行为及条幅内容</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">04</div>
                        <div class="ph-col-gr5 f16 tc fb">遛狗不牵绳识别</div>
                        <div class="white f16 tc pt40">重点区域遛狗不牵绳</div>
                    </div>
                    <img src="../../assets/mobile/images/gan-4.jpg" width="100%" height="100%" alt="" />
                </li>
                <li class="ov">
                    <img src="../../assets/mobile/images/gan-5.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">05</div>
                        <div class="ph-col-gr5 f16 tc fb">监所羁押人员行为识别</div>
                        <div class="white f16 tc pt40">打架自残等危险行为识别</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">06</div>
                        <div class="ph-col-gr5 f16 tc fb">同行人关系识别</div>
                        <div class="white f16 tc pt40">多人同行识别</div>
                    </div>
                    <img src="../../assets/mobile/images/gan-6.jpg" width="100%" height="100%" alt="" />
                </li>
            </ul>
        </div>
        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"> <span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-5.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z9-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>